<template>
    <div id="app" class="app" :class="$route.meta.className">
        <loading v-if="loading || fetching"></loading>
        <template v-if="!loading && !fetching">
            <component :is="layout"></component>
        </template>
        <notifications class="pop-notification" :max="1" position="top center"/>
    </div>
</template>

<script>
import DealerPortal from './api/DealerPortal';
import Dealer from './api/Dealer';
import EventBus from './event-bus';
import SecurityUtil from "./util/SecurityUtil";
import AppUtil from './util/AppUtil';
import {datadogRum} from "@datadog/browser-rum";

export default {
    name : 'app',
    data () {
        return {
            loading : true,
            fetching : true,
        }
    },
    computed : {
        layout () {
            return this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : 'AppLayout';
        }
    },
    beforeCreate() {

        //after we get a new version signal from the backend we set this key so we can redirect to it after performing
        //a hard reload using window.location.reload(true)
        const reloadPath = window.localStorage.getItem(AppUtil.VERSION_CHANGED_RELOAD_REDIRECT_TO_PATH_KEY);
        if(reloadPath) {
            window.localStorage.removeItem(AppUtil.VERSION_CHANGED_RELOAD_REDIRECT_TO_PATH_KEY);
            this.$router.push({ path : reloadPath });
        }

        EventBus.on(EventBus.EVENT.SESSION_SET, (dealerId) => {
            this.$store.dispatch(this.$STORE_CONSTANTS.CART.INITIALIZE, dealerId);
        });

        DealerPortal.get().then((response) => {
            if(!response.data){
                window.location.href = 'https://flxpoint.com';
                return;
            }

            if(window.location.hostname !== 'localhost') {

                const blackListed = [
                    'Uncaught {}',
                    '<error: unable to serialize object>',
                    'Uncaught "Empty reason"',
                    '[vee-validate] Validating a non-existent field',
                ]

                datadogRum.init({
                    applicationId : 'f183ce9d-c573-442f-8e46-b7953eaa8c1b',
                    clientToken : 'pubdee0422389d04b2c39a3c75932da24f4',
                    site : 'datadoghq.com',
                    service : 'dmx-dealers-frontend',
                    env : this.$isProdEnv() ? 'prod' : 'dev',
                    // Specify a version number to identify the deployed version of your application in Datadog
                    version : AppUtil.currentVersion(),
                    sampleRate : 100,
                    trackInteractions : true,
                    beforeSend : (event) => {
                        if(event.type === 'error' && blackListed.find(term => event.error.message.includes(term))) {
                            //discard the error
                            return false;
                        }

                        //add accountId
                        if(this.$getAccount()) {
                            event.context = {
                                ...event.context,
                                accountId : this.$getAccount().accountId,
                                dealerId : this.$getDealer().id,
                            }
                        }

                    }
                });
            }


            this.$store.commit('setDealerPortal', response.data);
            this.fetching = false;
        }).catch((error) => {
            //if this happens it means the token being used is no longer valid
            if(error.status === 401 || error.status === 403){
                SecurityUtil.removeToken();
                window.location.reload();
            }
        });
    },
    mounted() {

        if (window.localStorage.getItem('token')) {
            Dealer.get().then((response) => {
                this.$store.commit('setSessionContext', response.data);
                this.loading = false
            }).catch(() => {
                this.loading = false;
            });
        } else {
            if (this.$router.currentRoute.name !== 'login' && !this.$router.currentRoute.meta.no_session) {
                this.$router.push({ name : 'login' })
            }
            this.loading = false;
        }

    },
}
</script>

<style lang="scss">
    @import "assets/css/app.scss";
    @import '~bulma-extensions/bulma-calendar/dist/css/bulma-calendar.min.css';

</style>
